exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".description {\n  background-color: rgba(0, 0, 0, 0.9);\n  border-radius: 20px;\n  padding: 20px; }\n\ncarousel-img {\n  height: auto;\n  width: 200px; }\n\np {\n  font-size: 1vw; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/shared/Welcome.scss
// module id = 233
// module chunks = 0